module.exports = __webpack_public_path__ + "img/insta.c0634b26.svg";